var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "app",
    class: _vm.authLocked === true ? 'blured-5px' : ''
  }, [(_vm.isAuthenticated) ? _c('AppHeader', {
    attrs: {
      "list": _vm.list
    },
    on: {
      "lock": _vm.setAuthLock
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "app-body",
    class: _vm.impersonating ? 'impersonating-offset' : ''
  }, [_c('main', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('router-view')], 1)]), _vm._v(" "), _c('AppAside')], 1), _vm._v(" "), _c('AppFooter')], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15faad80","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Full.vue
// module id = 371
// module chunks = 0